import React, { useEffect, useState } from "react";
import { Link, withRouter, useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { updateAttendeeNew, getAttendeeByUserId } from "../../actions/attendeeActions";
import materialize from "materialize-css";
import Localization from "../localization/localization";
import StepWizard from "react-step-wizard";
import { PersonalInformation } from "./PersonalInformation";
import { CompanyInformation } from "./CompanyInformation";
//import { MainActivityCompany } from './MainActivityCompany'
import { MainActivityCompany } from './MainActivityOnly';
import { ProductsInterest } from './ProductsInterest'
import { TypeBusiness } from './TypeBusiness';
import { Target } from './Target';
import { ShuttleReservation } from './ShuttleReservation';
import { getStates, getCities } from "../../actions/countriesActions";

const CompradorEditNew = () => {
  const auth = useSelector((state) => state.auth);
  const { id } = useParams();
  const [state, updateState] = useState({
    form: {
      nacimiento: "",
      sexo: "",
      nombres: "",
      apellidos: "",
      email: auth.user.email,
      celular: "",
      ciudad: "",
      codigoPostal: "",

      //// Empresa
      nombreEmpresa: "",
      razonSocial: "",
      cargo: "",
      telefono: "",
      whatsapp: "",
      telefonoCodigoPais:"52",
      codigoPostalEmpresa: "",
      pais: "MX",
      estado: "",
      ciudadEmpresa: "",
      colonia: "",
      domicilio: "",
      domicilioNumero: "",
      wwwEmpresa: "",
      redesSocialesUrlEmpresa: "",

      //// Principal Actividad Empresa
      principalActividadVentaPublico: false,
      principalActividadMayoreo: false,
      principalActividadDistribuidor: false,
      principalActividadBrokerIntermediario: false,
      principalActividadConstruccionHospitalidad: false,
      principalActividadFabricante: false,
      principalActividadOtros: "",

      //// Giro de la empresa
      giroMuebleria: false,
      giroTiendaDepartamental: false,
      giroConstruccion: false,
      giroServicios: false,
      giroHotel: false,
      giroExportador: false,
      giroOtros: "",
      giroImportador: false,


      //// Mercado al que atiende
      mercadoAtiendeCorporativo: false,
      mercadoAtiendeHospitalidad: false,
      mercadoAtiendeResidencial: false,
      mercadoAtiendeConstruccion: false,
      mercadoAtiendeOtros: "",

      ///// Interes
      interesesAccesorios: false,
      interesesArteSacro: false,
      interesesCentrosEntretenimiento: false,
      interesesCocinas: false,
      interesesColchones: false,
      interesesComedores: false,
      interesesIluminacion: false,
      interesesMecedoras: false,
      interesesMesasCentroAuxiliares: false,
      interesesInfantilesJuveniles: false,
      interesesMuebleOficina: false,
      interesesOtros: "",
      interesesRecamarasLiteras: false,
      interesesLiterasMadera: false,
      interesesServicios: false,
      interesesTerrazaJardin: false,
      interesesTapizados: false,
      interesesTextiles: false,
      interesesTapetes: false,

      tamanioEmpresa: "",
      nsaClientes: "",
      proyectoActivo:"",

      //publicityYes: "",
      //publicityNo: "",
      /////
      //principalActividad: "",
      //productosInteres: "",
      categoria: "COMPRADOR",
      tipoRegistro: "pre",
      counter: 0,

      locale: "es",

      //vip: false,
      //errors: {}
      /*
      usarTransporteLlegada: "",
      fechaLlegada: "",
      horaLlegada: "",
      vueloLlegada: "",
      usarTransporteSalida: "",
      fechaSalida: "",
      horaSalida: "",
      vueloSalida: "",
      */
    }
    // demo: true, // uncomment to see more
  });
  const locale = Localization.getLocalizationInstance(localStorage.getItem("exmi_language"));
  const history = useHistory();
  const updateForm = (key, value) => {
    const { form } = state;
    form[key] = value;
    updateState({
      ...state,
      form,
    });
    if (key === "pais") {
      form["ciudad"] = "";
      updateState({
        ...state,
        form,
      });
      populateStates(value);
    }
    if (key === "estado") {
      if (form.pais === "MX" || form.pais === "US") {
        populateCities(form.pais, value);
      } else {
        form["cities"] = [];
        updateState({
          ...state,
          form,
        });
      }
    }
  };
  const submitForm = () => {
    let language = localStorage.getItem("exmi_language");
    if (language == null) language = "es";
    const { user } = auth;
    const existingAttendee = {
      userId: user.id,
      nacimiento: state.form.nacimiento,
      sexo: state.form.sexo,
      nombres: state.form.nombres,
      apellidos: state.form.apellidos,
      email: state.form.email,
      celular: state.form.celular,
      whatsapp: state.form.whatsapp,
      telefonoCodigoPais: state.form.telefonoCodigoPais,
      ciudad: state.form.ciudad,
      codigoPostal: state.form.codigoPostal,

      //// Empresa
      nombreEmpresa: state.form.nombreEmpresa,
      razonSocial: state.form.razonSocial,
      cargo: state.form.cargo,
      telefono: state.form.telefono,
      codigoPostalEmpresa: state.form.codigoPostalEmpresa,
      pais: state.form.pais,
      estado: state.form.estado,
      ciudadEmpresa: state.form.ciudadEmpresa,
      colonia: state.form.colonia,
      domicilio: state.form.domicilio,
      domicilioNumero: state.form.domicilioNumero,
      wwwEmpresa: state.form.wwwEmpresa,
      redesSocialesUrlEmpresa: state.form.redesSocialesUrlEmpresa,


      // Principal Actividad
      principalActividadVentaPublico: state.form.principalActividadVentaPublico,
      principalActividadMayoreo: state.form.principalActividadMayoreo,
      principalActividadDistribuidor: state.form.principalActividadDistribuidor,
      principalActividadBrokerIntermediario: state.form.principalActividadBrokerIntermediario,
      principalActividadConstruccionHospitalidad: state.form.principalActividadConstruccionHospitalidad,
      principalActividadFabricante: state.form.principalActividadFabricante,
      principalActividadOtros: state.form.principalActividadOtros,

      //// Giro de la empresa
      giroMuebleria: state.form.giroMuebleria,
      giroTiendaDepartamental: state.form.giroTiendaDepartamental,
      giroConstruccion: state.form.giroConstruccion,
      //giroEmpresa: state.form.giroEmpresa,
      giroHotel: state.form.giroHotel,
      //giroMayorista: state.form.giroMayorista,
      giroServicios: state.form.giroServicios,
      giroExportador: state.form.giroExportador,
      giroImportador: state.form.giroImportador,
      giroOtros: state.form.giroOtros,

      //// Mercado al que atiende
      mercadoAtiendeCorporativo: state.form.mercadoAtiendeCorporativo,
      mercadoAtiendeHospitalidad: state.form.mercadoAtiendeHospitalidad,
      mercadoAtiendeResidencial: state.form.mercadoAtiendeResidencial,
      mercadoAtiendeConstruccion: state.form.mercadoAtiendeConstruccion,
      mercadoAtiendeOtros: state.form.mercadoAtiendeOtros,

      ///// Interes
      interesesAccesorios: state.form.interesesAccesorios,
      interesesArteSacro: state.form.interesesArteSacro,
      interesesCentrosEntretenimiento: state.form.interesesCentrosEntretenimiento,
      interesesCocinas: state.form.interesesCocinas,
      interesesColchones: state.form.interesesColchones,
      interesesComedores: state.form.interesesComedores,
      interesesIluminacion: state.form.interesesIluminacion,
      interesesMecedoras: state.form.interesesMecedoras,
      interesesMesasCentroAuxiliares: state.form.interesesMesasCentroAuxiliares,
      interesesInfantilesJuveniles: state.form.interesesInfantilesJuveniles,
      interesesMuebleOficina: state.form.interesesMuebleOficina,
      interesesOtros: state.form.interesesOtros,
      interesesRecamarasLiteras: state.form.interesesRecamarasLiteras,
      interesesLiterasMadera: state.form.interesesLiterasMadera,
      interesesServicios: state.form.interesesServicios,
      interesesTapizados: state.form.interesesTapizados,
      interesesTerrazaJardin: state.form.interesesTerrazaJardin,
      interesesTextiles: state.form.interesesTextiles,
      interesesTapetes: state.form.interesesTapetes,

      tamanioEmpresa: state.form.tamanioEmpresa,
      nsaClientes: state.form.nsaClientes,
      proyectoActivo: state.form.proyectoActivo,

      categoria: state.form.categoria,
      tipoRegistro: state.form.tipoRegistro,

      locale: language,
      //vip: state.form.vip

      usarTransporteLlegada: state.form.usarTransporteLlegada,
      fechaHoraLlegada: ((state.form.fechaLlegada || "") + " " + (state.form.horaLlegada || "")).trim(),
      vueloLlegada: state.form.vueloLlegada || "",
      usarTransporteSalida: state.form.usarTransporteSalida,
      fechaHoraSalida: ((state.form.fechaSalida || "") + " " + (state.form.horaSalida || "")).trim(),
      vueloSalida: state.form.vueloSalida || "",
    }
    
    updateAttendeeNew(id, existingAttendee)
      .then((res) => history.push("/compradorlanding?action=update&id=" + existingAttendee.userId))
      .catch((error) => {
        materialize.toast({ html: locale.button_submission_error });
      });
  };
  // Do something on step change
  const onStepChange = (stats) => {
    window.scroll(0, 0);
    materialize.AutoInit();
    materialize.updateTextFields();
  };
  const setInstance = (SW) => updateState({
    ...state,
    SW,
  });

  useEffect(() => {
    
    getAttendeeByUserId(id)
      .then((response) => {
        if (response.data !== null) {
          const { form } = state;
          form.nacimiento = response.data.nacimiento !== undefined ? response.data.nacimiento : "";
          form.sexo = response.data.sexo !== undefined ? response.data.sexo : "";
          form.nombres = response.data.nombres !== undefined ? response.data.nombres : "";
          form.apellidos = response.data.apellidos !== undefined ? response.data.apellidos : "";
          form.email = response.data.email !== undefined ? response.data.email : "";
          form.celular = response.data.celular !== undefined ? response.data.celular : "";
          form.whatsapp = response.data.whatsapp !== undefined ? response.data.whatsapp : "";
          form.telefonoCodigoPais = response.data.telefonoCodigoPais !== undefined ? response.data.telefonoCodigoPais : "";
          form.ciudad = response.data.ciudad !== undefined ? response.data.ciudad : "";
          form.codigoPostal = response.data.codigoPostal !== undefined ? response.data.codigoPostal : "";
          form.nombreEmpresa = response.data.nombreEmpresa !== undefined ? response.data.nombreEmpresa : "";

          form.razonSocial = response.data.razonSocial !== undefined ? response.data.razonSocial : "";
          form.cargo = response.data.cargo !== undefined ? response.data.cargo : "";
          form.telefono = response.data.telefono !== undefined ? response.data.telefono :"";
          form.emailEmpresa = response.data.emailEmpresa !== undefined ? response.data.emailEmpresa : "";
          form.codigoPostalEmpresa = response.data.codigoPostalEmpresa !== undefined ? response.data.codigoPostalEmpresa : "";
          form.pais = response.data.pais !== undefined ? response.data.pais : "";
          form.estado = response.data.estado !== undefined ? response.data.estado : "";
          form.ciudadEmpresa = response.data.ciudadEmpresa !== undefined ? response.data.ciudadEmpresa : "";
          form.colonia = response.data.colonia !== undefined ? response.data.colonia : "";
          form.domicilio = response.data.domicilio !== undefined ? response.data.domicilio : "";
          form.domicilioNumero = response.data.domicilioNumero !== undefined ? response.data.domicilioNumero : "";
          form.wwwEmpresa = response.data.wwwEmpresa !== undefined ? response.data.wwwEmpresa : "";
          form.redesSocialesUrlEmpresa = response.data.redesSocialesUrlEmpresa !== undefined ? response.data.redesSocialesUrlEmpresa : "";

          form.principalActividadVentaPublico = ((response.data.principalActividadVentaPublico === "true") ? true : false);
          form.principalActividadMayoreo = ((response.data.principalActividadMayoreo === "true") ? true : false);
          form.principalActividadDistribuidor = ((response.data.principalActividadDistribuidor === "true") ? true : false);
          form.principalActividadBrokerIntermediario = ((response.data.principalActividadBrokerIntermediario === "true") ? true : false);
          form.principalActividadConstruccionHospitalidad = ((response.data.principalActividadConstruccionHospitalidad === "true") ? true : false);
          form.principalActividadFabricante = ((response.data.principalActividadFabricante === "true") ? true : false);
          form.principalActividadOtros = response.data.principalActividadOtros !== undefined ? response.data.principalActividadOtros : "";

          form.giroMuebleria = ((response.data.giroMuebleria === "true") ? true : false);
          form.giroTiendaDepartamental = ((response.data.giroTiendaDepartamental === "true") ? true : false);
          form.giroConstruccion = ((response.data.giroConstruccion === "true") ? true : false);
          form.giroHotel = ((response.data.giroHotel === "true") ? true : false);
          form.giroServicios = ((response.data.giroServicios === "true") ? true : false);
          form.giroExportador = ((response.data.giroExportador === "true") ? true : false);
          form.giroImportador = ((response.data.giroImportador === "true") ? true : false);
          form.giroOtros = response.data.giroOtros !== undefined ? response.data.giroOtros : "";

          form.mercadoAtiendeCorporativo = ((response.data.mercadoAtiendeCorporativo === "true") ? true : false);
          form.mercadoAtiendeHospitalidad = ((response.data.mercadoAtiendeHospitalidad === "true") ? true : false);
          form.mercadoAtiendeResidencial = ((response.data.mercadoAtiendeResidencial === "true") ? true : false);
          form.mercadoAtiendeConstruccion = ((response.data.mercadoAtiendeConstruccion === "true") ? true : false);
          form.mercadoAtiendeOtros = response.data.mercadoAtiendeOtros !== undefined ? response.data.mercadoAtiendeOtros : "";

          form.interesesAccesorios = ((response.data.interesesAccesorios === "true") ? true : false);
          form.interesesCentrosEntretenimiento = ((response.data.interesesCentrosEntretenimiento === "true") ? true : false);
          form.interesesCocinas = ((response.data.interesesCocinas === "true") ? true : false);
          form.interesesColchones = ((response.data.interesesColchones === "true") ? true : false);
          form.interesesComedores = ((response.data.interesesComedores === "true") ? true : false);
          form.interesesInfantilesJuveniles = ((response.data.interesesInfantilesJuveniles === "true") ? true : false);
          form.interesesMuebleOficina = ((response.data.interesesMuebleOficina === "true") ? true : false);
          form.interesesRecamarasLiteras = ((response.data.interesesRecamarasLiteras === "true") ? true : false);
          form.interesesServicios = ((response.data.interesesServicios === "true") ? true : false);
          form.interesesTapizados = ((response.data.interesesTapizados === "true") ? true : false);
          form.interesesTerrazaJardin = ((response.data.interesesTerrazaJardin === "true") ? true : false);
          form.interesesTextiles = ((response.data.interesesTextiles === "true") ? true : false);
          form.interesesArteSacro = ((response.data.interesesArteSacro === "true") ? true : false);
          form.interesesIluminacion = ((response.data.interesesIluminacion === "true") ? true : false);
          form.interesesMecedoras = ((response.data.interesesMecedoras === "true") ? true : false);
          form.interesesMesasCentroAuxiliares = ((response.data.interesesMesasCentroAuxiliares === "true") ? true : false);
          form.interesesLiterasMadera = ((response.data.interesesLiterasMadera === "true") ? true : false);
          form.interesesTapetes = ((response.data.interesesTapetes === "true") ? true : false);
          form.interesesOtros = response.data.interesesOtros !== undefined ? response.data.interesesOtros : "";

          form.tamanioEmpresa = response.data.tamanioEmpresa !== undefined ? response.data.tamanioEmpresa : "";
          form.nsaClientes = response.data.nsaClientes !== undefined ? response.data.nsaClientes : "";
          form.proyectoActivo = response.data.proyectoActivo !== undefined ? response.data.proyectoActivo : "";
          

          form.locale = response.data.locale;

          form.categoria = "COMPRADOR";

          form.usarTransporteLlegada = response.data.usarTransporteLlegada !== undefined
            ? response.data.usarTransporteLlegada
            : "";
          form.fechaLlegada = response.data.fechaHoraLlegada
            ? response.data.fechaHoraLlegada.split(' ')[0]
            : "";
          form.horaLlegada = response.data.fechaHoraLlegada
            ? response.data.fechaHoraLlegada.split(' ')[1]
            : "";
          form.vueloLlegada = response.data.vueloLlegada !== undefined
            ? response.data.vueloLlegada
            : "";
          form.usarTransporteSalida = response.data.usarTransporteSalida !== undefined
            ? response.data.usarTransporteSalida
            : "";
          form.fechaSalida = response.data.fechaHoraSalida
            ? response.data.fechaHoraSalida.split(' ')[0]
            : "";
          form.horaSalida = response.data.fechaHoraSalida
            ? response.data.fechaHoraSalida.split(' ')[1]
            : "";
          form.vueloSalida = response.data.vueloSalida !== undefined
            ? response.data.vueloSalida
            : "";

          //form.vip = ((response.data.vip === "true") ? true : false);
          //form.vipProcessed = ((response.data.vipProcessed === "true") ? true : false);

          updateState({
            ...state,
            form,
          });
        }

        /*
        this.disableControlsByClass("PrincipalActividad", 3);
        this.disableControlsByClass("Giro", 3);
        //this.disableControlsByClass("MotivoAsistencia", 3);
        this.disableControlsByClass("ProductosInteres", 3);
        //this.disableControlsByClass("EnterasteEvento", 3);
        this.disableControlsByClass("MercadoAtiende", 3);
        */

        materialize.AutoInit();
        materialize.updateTextFields();

        return response.data;
      })
      .then((res) => {
        populateStates(res.pais);
        populateCities(res.pais, res.estado);
      })
      .catch((error) => console.log(error));
    materialize.AutoInit();
    materialize.updateTextFields();

    //this.sortChildrenHtmlElementsByParentClass('MotivoAsistenciaParent');
    //this.sortChildrenHtmlElementsByParentClass('ProductosInteresParent');
  }, []);
  const populateStates = (country) => {
    let states = [];
    getStates(country)
      .then((response) => {
        states = response.data[0].states.map((state) => {
          return (
            <option key={state} value={state}>
              {state}
            </option>
          );
        });
        const { form } = state;
        form.states = states;
        updateState({
          ...state,
          form,
        });
      })
      .catch((err) => console.log(err));
  };
  const populateCities = (country, state_) => {
    let cities = [];
    getCities(country, state_)
      .then((response) => {
        cities = response.data.map((city) => {
          return (
            <option key={city} value={city}>
              {city}
            </option>
          );
        });
        const { form } = state;
        form.cities = cities;
        updateState({
          ...state,
          form,
        });
        materialize.AutoInit();
        materialize.updateTextFields();
      })
      .catch((err) => console.log(err));
  };
  return (
    <div className="col s12 m12 l7 container contentaligned overflowDiv">
      <Link to="/Dashboard" className="btn-flat waves-effect">
        <i className="material-icons left">keyboard_backspace</i> {locale.dashboard_comprador_label_backtohome}
      </Link>
      <StepWizard onStepChange={onStepChange} instance={setInstance}>
        <PersonalInformation update={updateForm} locale={locale} form={state.form} />
        <CompanyInformation update={updateForm} locale={locale} form={state.form} />
        <TypeBusiness update={updateForm} locale={locale} form={state.form} />
        <MainActivityCompany update={updateForm} locale={locale} form={state.form} />
        {/*<Target update={updateForm} locale={locale} form={state.form} submit={submitForm} />*/}
        {/*<ShuttleReservation update={updateForm} locale={locale} form={state.form} submit={submitForm} />*/}
        <ProductsInterest update={updateForm} locale={locale} form={state.form} submit={submitForm} />
      </StepWizard>
    </div>
  );
};
export default withRouter(CompradorEditNew);
